"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeDeliverType = exports.serializeDeliverType = void 0;
const core_1 = require("../../core");
const report_1 = require("./report");
const serializeDeliverType = (deliverType) => deliverType.toString();
exports.serializeDeliverType = serializeDeliverType;
const deserializeDeliverType = (deliverTypeStr) => {
    switch (deliverTypeStr) {
        case 'email':
            return report_1.DeliverType.EMAIL;
        default:
            throw new core_1.BadDeliverTypeError(`Unsupported DeliverType '${deliverTypeStr}'. Allowed values are ${Object.values(report_1.DeliverType).join(', ')}`);
    }
};
exports.deserializeDeliverType = deserializeDeliverType;
//# sourceMappingURL=serdes.js.map